var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNodeIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_26",
    "data-name": "Subtraction 26",
    d: "M9,18a9,9,0,1,1,9-9A9.01,9.01,0,0,1,9,18Zm.018-7.252h0l2.9,2.938,1.746-1.746L10.762,9l2.9-2.941L11.919,4.313l-2.9,2.939L6.081,4.315,4.335,6.061,7.275,9,4.335,11.939l1.746,1.746,2.936-2.936Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNodeIcons);
export default __webpack_public_path__ + "static/media/close_node_icons.a0aaedab05fec8b68a1df0982bd86db0.svg";
export { ForwardRef as ReactComponent };